import { render, staticRenderFns } from "./CustomerInvoice.vue?vue&type=template&id=0f527c09&scoped=true"
import script from "./CustomerInvoice.vue?vue&type=script&lang=js"
export * from "./CustomerInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f527c09",
  null
  
)

export default component.exports